import React, { useState, useEffect } from "react";
import { Table,Button } from "react-bootstrap";
import { useGetAllInvoicesByIdQuery } from "./ProcurementApiSlice";
import { AdminAllDoc } from "./AdminAllDoc";
const ViewInvoice = ({ procId, invoice, FullList }) => {
  const { data: invoiceAll } = useGetAllInvoicesByIdQuery(procId);
  const [generatedInvoices, setGeneratedInvoices] = useState([]);
  const [updatedList, setUpdatedList] = useState([]);
  const [updatedListBuyer, setupdatedListBuyer] = useState([]);
  console.log("invoice", invoice);
  useEffect(() => {
    if (invoiceAll) {
      setGeneratedInvoices(invoiceAll?.data);
    }
    const updatedList = FullList?.all_media?.filter(
      (item) => item.entity_type === "Seller" && item.file_extension === "pdf"
    );
    setUpdatedList(updatedList);
    const updatedListBuyer = FullList?.all_media?.filter(
      (item) => item.entity_type === "Buyer" && item.file_extension === "pdf"
    );
    setupdatedListBuyer(updatedListBuyer);
  }, [invoiceAll, FullList]);

  const handleDownload = (fileUrl) => {
    if (fileUrl && fileUrl.includes(invoice)) {
      window.open(fileUrl, "_blank");
    }
  };

  const handleViewPdf = (url) => {
    window.open(url, "_blank");
  };
  const handleGenerateContractNote = (data) => {
    const filteredData = FullList?.all_media.filter(
      (item) => item.pattern === "Contract Note"
    );
    if (filteredData.length > 0) {
      const anchor = document.createElement("a");
      anchor.href = filteredData[0].file;
      anchor.download = `Contract_Note.${filteredData[0].file_extension}`;
      anchor.target = "_blank";
      anchor.click();
    } else {
      console.error('No invoices matching pattern "B2S" found.');
    }
  };
  return (
    <div className="p-2">
      {generatedInvoices?.length > 0 ? (
        <div>
          <h4>Generated Invoices & Contract Note</h4>
          <Table
            border="1"
            striped
            hover
            style={{ width: "100%", marginTop: "10px" }}
          >
            <thead>
              <tr>
                {/* <th>Invoice </th> */}
                <th> Invoice</th>
                <th>Location</th>

                <th>View Document</th>
                <th>Contract Note</th>

              </tr>
            </thead>
            <tbody>
              {generatedInvoices?.map((field, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{field.stock_location}</td>

                    {/* <td>{field?.stock_location?.address}, {field?.stock_location?.district}, {field?.stock_location?.state}</td> */}
                    <td>
                      {field?.invoice_documents
                        ?.filter((item) => item.file.includes(invoice))
                        ?.map((item) => (
                          <div key={item.id}>
                            <a
                              href={item.file}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Document
                            </a>
                          </div>
                        ))}
                    </td>
                    <td> <Button
  className="buttonOrangeDefaultColor"
      size="sm"
      onClick={() => handleGenerateContractNote(FullList)}
    >
        Contract Note <i class="mdi mdi-download"></i>
        </Button></td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        ""
      )}
      <AdminAllDoc procList={FullList} />
    </div>
  );
};

export default ViewInvoice;
